import { useEffect, useState } from 'react';
import { KeyRound } from 'lucide-react';
import * as ivyChatApi from '../../services/ivyChatApi';
import { QUALITY_TIER_OPTIONS } from '../../types/models';
import { ClaudeTokenModal } from '../agent-chat/ClaudeTokenModal';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { SettingsPanel } from './SettingsPanel';

export function AdvancedSettings() {
  const [keyOpen, setKeyOpen] = useState(false);
  const [keyStatus, setKeyStatus] = useState<{ hasToken: boolean; hint: string | null } | null>(null);

  const refresh = async () => {
    try {
      const s = await ivyChatApi.getProviderStatus();
      setKeyStatus({ hasToken: s.hasAnyKey, hint: s.providers[s.activeProvider]?.hint || null });
    } catch {
      setKeyStatus(null);
    }
  };

  useEffect(() => { void refresh(); }, []);

  return (
    <div className="grid gap-4">
      <SettingsPanel>
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <h2 className="flex items-center gap-2 font-semibold"><KeyRound className="h-4 w-4" /> Your own model key</h2>
            <p className="mt-1 text-sm text-muted-foreground">Optional. Your own model key is used for the agent's work; credits still apply.</p>
            {keyStatus?.hasToken && keyStatus.hint && <p className="mt-1 font-mono text-xs text-muted-foreground">{keyStatus.hint}</p>}
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <Badge variant={keyStatus?.hasToken ? 'default' : 'secondary'}>{keyStatus?.hasToken ? 'Connected' : 'Not set'}</Badge>
            <Button variant="outline" size="sm" onClick={() => setKeyOpen(true)}>{keyStatus?.hasToken ? 'Manage key' : 'Add key'}</Button>
          </div>
        </div>
      </SettingsPanel>
      <SettingsPanel title="Quality">
        <p className="text-sm text-muted-foreground">
          You choose the quality for each video when you start it: {QUALITY_TIER_OPTIONS.filter((t) => !t.comingSoon).map((t) => t.label).join(', ')}. Higher quality uses more credits.
        </p>
      </SettingsPanel>
      <ClaudeTokenModal open={keyOpen} onClose={() => { setKeyOpen(false); void refresh(); }} />
    </div>
  );
}
